export default /*@ngInject*/ function ($http, errorsDataService) {
    const service = {
        getProducts,
        getLatestProductImports,
        getHybridConnections,
        getPlugins,
        getConnectionSql,
        getConnections,
        getLogAnalyticConnections,
        getProductSchedule,
        getProductSql,
        getSapProduct,
        getImportRoles,
        getOracleEpmServiceTypes,
        getSfPermissionConfig,
        getSfPermissionConfigByObject,
        getProductLogo,
        getUpiDataSources,
        getProductById,
        getDataMappingsByProductId,
        getUpiTargetMetadata,
        getSourceMetadata,
        exportMappings,
        importMappings,
        importSecurity,
        importFromFileUpload,
        createNewProduct,
        updateProductName,
        updateProductSchedule,
        disableProductSchedule,
        updateConfig,
        updateSqlConfig,
        createSqlConfig,
        updateCustomProductConnection,
        createLogAnalyticsConfig,
        updateLogAnalyticsConfig,
        validateNsConfig,
        updateSapProduct,
        createSapProduct,
        createSfFieldPermissionConfig,
        importProductLogo,
        saveDataMappings,
        deleteProductLogo,
        deleteProduct,
        removeSfFieldPermissionConfig
    };

    return service;

    //GET Requests
    async function getProducts() {
        try {
            return $http.get(apiUrl + 'api/universal/products');
        } catch (err) {
            showError(err);
        }
    }

    async function getLatestProductImports() {
        return $http.get(apiUrl + 'api/universal/imports/products/latest');
    }

    async function getHybridConnections() {
        return $http.get(apiUrl + 'api/core/hybridconnections');
    }

    async function getPlugins() {
        return $http.get(`${apiUrl}api/core/plugins`);
    }

    async function getConnectionSql(productId) {
        return $http.get(apiUrl + 'api/universal/products/' + productId + '/connections/sql');
    }

    async function getConnections(productId) {
        return $http.get(apiUrl + 'api/universal/products/' + productId + '/connections');
    }

    async function getLogAnalyticConnections(productId) {
        return $http.get(`${apiUrl}api/assure/log-analytics/connection/${productId}`);
    }


    async function getProductSchedule(productId) {
        return $http.get(apiUrl + 'api/universal/imports/schedule/products/' + productId);
    }

    async function getProductSql(productId) {
        return $http.get(apiUrl + 'api/universal/products/' + productId + '/connections/sql');
    }

    async function getSapProduct(productId) {
        return $http.get(apiUrl + 'api/universal/products/' + productId + '/connections/saprfc');
    }

    async function getImportRoles(productId) {
        let response;

        try {
            response = await $http.get(apiUrl + 'api/universal/' + productId + '/import/api/role');
        } catch (err) {
            showError({
                data: "Unable to get import roles."
            });
            sendError(err);
        }

        return response;
    }

    async function getOracleEpmServiceTypes() {
        let response;

        try {
            response = await $http.get(apiUrl + 'api/assure/orepm/services');
        } catch (err) {
            showError({
                data: "Unable to get service types"
            });
            sendError(err);
        }

        return response;
    }

    async function getSfPermissionConfig() {
        return $http.get(apiUrl + 'api/universal/sf/import/fieldpermissionconfig');
    }

    async function getSfPermissionConfigByObject(name) {
        return $http.get(apiUrl + 'api/universal/sf/import/fieldpermissionconfig/' + name + '/fields');
    }

    async function getProductLogo(productId) {
        return await $http.get(`${apiUrl}api/universal/custom-product/images/${productId}`);
    }

    async function getProductById(id) {
        try {
            return await $http.get(`${apiUrl}api/universal/products/${id}`);
        } catch (err) {
            showError(err);
        }
    }

    async function getDataMappingsByProductId(id) {
        try {
            return await $http.get(`${apiUrl}api/universal/products/${id}/data-mappings`);
        } catch (err) {
            showError(err);
        }
    }

    async function getUpiDataSources() {
        try {
            return await $http.get(apiUrl + 'api/universal/connections/data-sources');
        } catch (err) {
            showError(err);
        }
    }

    async function getUpiTargetMetadata(productId, type) {
        try {
            return await $http.get(`${apiUrl}api/universal/${productId}/import/target-metadata/${type}`);
        } catch (err) {
            showError(err);
        }
    }

    async function getSourceMetadata(productId, importType, data) {
        try {
            let urlString = `${apiUrl}api/universal/${productId}/import/${importType}/source-metadata`;
            if (importType === 'excel' || importType === 'csv' || importType === 'rest-api') {
                return await $http.post(urlString, data, {
                    transformRequest: angular.identity,
                    headers: { 'Content-Type': undefined }
                });
            } else {
                return await $http.post(urlString);
            }
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function exportMappings(productId) {
        try {
            return await $http.get(`${apiUrl}api/universal/products/${productId}/data-mappings/export`, { responseType: "blob" });
        } catch (err) {
            showError(err);
        }
    }

    async function importMappings(productId, fd) {
        try {
            return await $http.put(`${apiUrl}api/universal/products/${productId}/data-mappings/import`, fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }


    async function importSecurity(url, data) {
        try {
            await $http.put(url, data);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function importFromFileUpload(url, data) {
        try {
            await $http.put(url, data, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function createNewProduct(data) {
        let response;

        try {
            response = await $http({
                method: 'POST',
                url: apiUrl + 'api/universal/products',
                data: data
            });
        } catch (err) {
            showError(err);
            sendError(err);
        }

        return response;
    }

    async function updateProductName(productId, putData) {
        try {
            await $http.put(apiUrl + 'api/universal/products/' + productId, putData);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function updateProductSchedule(productId, data) {
        let response;

        try {
            response = await $http.put(apiUrl + 'api/universal/imports/schedule/products/' + productId, data);
        } catch (err) {
            showError(err);
            sendError(err);
        }

        return response;
    }

    async function createSapProduct(productId, data) {
        try {
            await $http.post(apiUrl + 'api/universal/products/' + productId + '/connections/saprfc', data);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function validateNsConfig(data) {
        try {
            await $http.put(apiUrl + 'api/core/ns/configuration/validate', data)
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function updateSapProduct(productId, data) {
        try {
            await $http.put(apiUrl + 'api/universal/products/' + productId + '/connections/saprfc', data);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function disableProductSchedule(productId, data) {
        let response;

        try {
            response = await $http.put(apiUrl + 'api/universal/imports/schedule/products/' + productId + "/disable", data);
        } catch (err) {
            showError(err);
            sendError(err);
        }

        return response;
    }

    async function updateConfig(data) {
        let response;
        try {
            response = $http.put(apiUrl + 'api/core/configuration', data);
        } catch (err) {
            showError(err);
            sendError(err);
        }

        return response;
    }

    async function updateSqlConfig(productId, data) {
        let response;

        try {
            response = await $http.put(apiUrl + 'api/universal/products/' + productId + '/connections/sql', data);
        } catch (err) {
            showError(err);
            sendError(err);
        }

        return response;
    }

    async function createSqlConfig(productId, data) {
        let response;

        try {
            response = await $http.post(apiUrl + 'api/universal/products/' + productId + '/connections/sql', data);
        } catch (err) {
            showError(err);
            sendError(err);
        }

        return response;
    }

    async function updateCustomProductConnection(productId, productConnectionId, data) {
        try {
            return await $http.put(apiUrl + 'api/universal/products/' + productId + '/connections/' + productConnectionId, data);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function createLogAnalyticsConfig(productId, data) {
        try {
            return await $http.post(`${apiUrl}api/assure/log-analytics/connection/${productId}`, data);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function updateLogAnalyticsConfig(productId, data) {
        try {
            return await $http.put(`${apiUrl}api/assure/log-analytics/connection/${productId}`, data);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function createSfFieldPermissionConfig(data) {
        let response;

        try {
            response = await $http.post(apiUrl + 'api/universal/sf/import/fieldpermissionconfig', data);
        } catch (err) {
            showError(err);
        }

        return response;
    }

    async function importProductLogo(fd) {
        try {
            return await $http.post(`${apiUrl}api/universal/custom-product/images`, fd, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function saveDataMappings(productId, postBody) {
        try {
            return await $http.post(`${apiUrl}api/universal/products/${productId}/data-mappings`, postBody)
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function deleteProductLogo(id) {
        return await $http.delete(`${apiUrl}api/universal/custom-product/images/${id}`);
    }

    async function deleteProduct(id) {
        try {
            return await $http.delete(`${apiUrl}api/universal/products/${id}`);
        } catch (err) {
            showError(err);
            sendError(err);
        }
    }

    async function removeSfFieldPermissionConfig(fieldId) {
        try {
            await $http.delete(apiUrl + 'api/universal/sf/import/fieldpermissionconfig/' + fieldId);
        } catch (err) {
            showError(err);
        }
    }

    function sendError(err) {
        throw err;
    }

    function showError(err) {
       errorsDataService.catch(err);
    }
}